import React from 'react';
import ReactDOM from 'react-dom';
import CalculatorTitleFees from './app/containers/CalculatorTitleFees/CalculatorTitleFees';
import CalculatorRefinance from './app/containers/CalculatorRefinance/CalculatorRefinance';
import CalculatorSellersNet from './app/containers/CalculatorSellersNet/CalculatorSellersNet';

const calculatorId = document.getElementById('app-calculator');
const { calculator, calculatorConstants } = $(calculatorId).data();

const CalulatorApp = ({ calculator, ...props }) => {
  const calculators = {
    'commercial-title-fees': {
      type: 'commercial',
      component: CalculatorTitleFees,
    },
    'commercial-refinance': {
      type: 'commercial',
      component: CalculatorRefinance,
    },
    'residential-title-fees': {
      type: 'residential',
      component: CalculatorTitleFees,
    },
    'residential-refinance': {
      type: 'residential',
      component: CalculatorRefinance,
    },
    'residential-sellers-net-sheet': {
      type: 'residential',
      component: CalculatorSellersNet,
    },
  };
  const { type, component: CalculatorComponent } = calculators[calculator];
  return <CalculatorComponent {...props} calculatorType={type} />;
};

ReactDOM.render(
  <CalulatorApp
    calculator={calculator}
    calculatorConstants={calculatorConstants}
  />,
  calculatorId
);
